import type { QueryClient } from '@tanstack/react-query';
import type { UseAuthStore } from '#src/state/AuthStore.ts';
import {
  createRootRouteWithContext,
  Outlet,
  Scripts,
  HeadContent as TanstackHeadContent
} from '@tanstack/react-router';
import * as React from 'react';
import { HeadContent, HeadProvider } from '@_/components';
import { DEFAULT_TEXT_SIZE } from '@_/theme/constants.ts';
import appCss from '../style.css?url';

interface RouterContext {
  queryClient: QueryClient;
  useAuthStore: UseAuthStore;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ],
    links: [
      { rel: 'icon', href: '/favicon.ico', sizes: '32x32' },
      { rel: 'icon', href: '/favicon.svg', type: 'image/svg+xml' },
      { rel: 'apple-touch-icon', href: '/favicon-180.png' },
      { rel: 'manifest', href: '/manifest.webmanifest' },
      { rel: 'stylesheet', href: appCss }
    ]
  }),
  component: RootComponent,
  shellComponent: RootShell,
  ssr: true
});

function RootShell({ children }: React.PropsWithChildren) {
  return (
    <html>
      <head>
        <TanstackHeadContent />
      </head>
      <body className={DEFAULT_TEXT_SIZE}>
        <HeadProvider>
          {children}
          <HeadContent />
        </HeadProvider>
        <Scripts />
      </body>
    </html>
  );
}

function RootComponent() {
  return <Outlet />;
}
